import { useNavigate, useParams } from 'react-router'
import { HubManifests } from './HubManifests'
import { HubReceiving } from './HubReceiving'

/** Receiving at the hub: the batches at the door, or the one being received. */
export function ReceivingTab() {
	const navigate = useNavigate()
	const { manifestId } = useParams()

	if (manifestId) {
		return (
			<HubReceiving
				key={manifestId}
				manifestId={manifestId}
				onBack={() => navigate('/hub')}
			/>
		)
	}
	return (
		<HubManifests
			onOpen={(id) => navigate(`/hub/receiving/${encodeURIComponent(id)}`)}
		/>
	)
}
